import useBeautyFilterImageStore from 'stores/beautyFilter/beautyFilterImageStore';
import { useEffect } from 'react';

const useBeautyFilterImage = (imageSrc: string) => {
  const { startLoadingImage, endLoadingImage } = useBeautyFilterImageStore();

  useEffect(() => {
    if (imageSrc) startLoadingImage(imageSrc);
  }, [imageSrc, startLoadingImage]);

  return { endLoadingImage };
};

export default useBeautyFilterImage;
